import { Component, OnInit, ElementRef, ViewChild, Renderer2, HostListener } from '@angular/core';
import { UtilsService } from '../../services/utils.service';
import { Deserialize } from 'cerialize';
declare var window: any;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  name: string;

  notification: any;
  notificationOffcanvas: any;
  showNotificationCanvas: boolean = false;

  serviceAcessUserRole = [1];
  salesBothAccessUserRole = [4, 5];
  salesAccessUserRole = [4];

  @ViewChild('mainHeader') mainHeader!: ElementRef;
  @ViewChild('menuOverlay') menuOverlay!: ElementRef;
  @ViewChild('navbarToggler') navbarToggler!: ElementRef;

  constructor(public utilsService: UtilsService, private renderer: Renderer2) { }
  userDetail = JSON.parse(sessionStorage.getItem('user'));
  ngOnInit() {
    const obj = this.utilsService.getLoginUsers()
    if (obj) {
      this.name = `${obj.fname} ${obj.lname} `

    }

    this.notificationOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById('notificationOffcanvas')
    );

    document.getElementById('notificationOffcanvas').addEventListener('hidden.bs.offcanvas', () => {
      this.showNotificationCanvas = false;
    });

    // this.getNotification();
  }

  logout(): void {
    // sessionStorage.clear();
    // localStorage.clear();
    // this.utilsService.redirectTo('/auth/login');

    const param = {};
    let userDetail = JSON.parse(sessionStorage.getItem('user'));

    const Id = userDetail.id;

    this.utilsService.postMethodAPI(true, this.utilsService.serverVariableService.LOGOUT_API + `/${Id}`, param, (response) => {
      sessionStorage.clear();
      localStorage.clear();
      this.utilsService.redirectTo('/auth/login');
    });
    sessionStorage.clear();
    localStorage.clear();
    this.utilsService.redirectTo('/auth/login');
  }

  openOffCanvas() {
    this.showNotificationCanvas = true;
    this.getNotification();
    this.utilsService.countOfNotification = 0;
  }

  getNotification() {
    this.notification = []
    let userDetail = JSON.parse(sessionStorage.getItem('user'));

    const param = {};
    this.utilsService.getMethodAPI(this.utilsService.serverVariableService.GET_NOTIFICATION_API + `/${userDetail.id}`, param, (response) => {

      if (!this.utilsService.isNullUndefinedOrBlank(response)) {
        this.notification = Deserialize(response);
        // this.utilsService.countOfNotification = this.notification.length;
      }
    });
  }



  /** ✅ Menu Toggle Logic - converted from jQuery */
  toggleMobileMenu(event: MouseEvent): void {
    event.stopPropagation(); // Prevent bubbling
    this.renderer.addClass(document.body, 'mobile-menu-active');
    this.renderer.addClass(document.documentElement, 'overflow-hidden'); // HTML element
    this.renderer.addClass(this.mainHeader.nativeElement, 'mobile-header');
  }


  /** ✅ Close Mobile Menu */
  closeMobileMenu(): void {
    this.renderer.removeClass(document.body, 'mobile-menu-active');
    this.renderer.removeClass(document.documentElement, 'overflow-hidden');
    this.renderer.removeClass(this.mainHeader.nativeElement, 'mobile-header');
  }

  /** ✅ Close on Escape key */
  @HostListener('document:keydown', ['$event'])
  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      this.closeMobileMenu();
    }
  }

  /** ✅ Close on click outside */
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const clickedInsideHeader = this.mainHeader?.nativeElement?.contains(event.target);
    const clickedNavbarToggler = this.navbarToggler?.nativeElement?.contains(event.target);

    if (!clickedInsideHeader && !clickedNavbarToggler) {
      this.closeMobileMenu();
    }
  }
  onNavLinkClick(): void {
    this.closeMobileMenu();
  }
  handleShowTab(userRole: any, allowedRoles: number[]): boolean {
    if (!userRole) return false;
    return allowedRoles.includes(Number(userRole));
  }

  handleNavigateToDashboard() {
    switch (this.userDetail.userRole) {
      case 1: {
        this.utilsService.redirectTo('admin/work_area/dashboard');
        break;
      }
      case 4: {
        this.utilsService.redirectTo('admin/work_area/sales-order/list');
        break;
      }
      case 5: {
        this.utilsService.redirectTo('admin/work_area/sales-order/list');
        break;
      }

    }
  }

}
